module.exports = __webpack_public_path__ + "img/palo.343d72f9.png";